import styled from '@emotion/styled';
import { Grid, Typography } from '@material-ui/core';
import { FC, Fragment } from 'react';
import StyledInputField from '../../../primitive/StyledInputField';
import StyledTextarea from '../../../primitive/StyledTextarea';
import InputError from '../InputError';
import InputFieldLabel from '../InputFieldLabel';

type Props = {
  title: string;
  setTitle: (value: React.SetStateAction<string>) => void;
  description: string;
  setDescription: (value: React.SetStateAction<string>) => void;
};

const NameContent: FC<Props> = ({ title, setTitle, description, setDescription }) => {
  return (
    <Fragment>
      <StyledGrid item xs={12}>
        <FormLabelWrapper>
          <InputFieldLabel>ゴールの名前</InputFieldLabel>
          <RequiredLabel>必須</RequiredLabel>
        </FormLabelWrapper>
        <StyledInputField
          value={title}
          onChange={(e) => {
            setTitle(e.target.value);
          }}
          error={title.length > 50}
        />
        {title.length > 50 && <InputError>50文字以内で入力してください</InputError>}
      </StyledGrid>
      <Grid item xs={12}>
        <FormLabelWrapper>
          <InputFieldLabel>ゴールの概要</InputFieldLabel>
        </FormLabelWrapper>
        <StyledTextarea
          value={description}
          onChange={(e) => {
            if (e.target.value.length <= 120) {
              setDescription(e.target.value);
            }
          }}
          error={description.length > 120}
        />
        {description.length > 120 && <InputError>120文字以内で入力してください</InputError>}
      </Grid>
    </Fragment>
  );
};

const StyledGrid = styled(Grid)`
  margin-bottom: 48px;
`;

const RequiredLabel = styled(Typography)`
  font-weight: 400;
  font-size: 10px;
  line-height: 160%;
  color: #bf4140;
  margin-left: 4px;
`;

const FormLabelWrapper = styled('div')`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export default NameContent;
